import styled from "styled-components";

export const ProductDetail = styled.div`
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
  overflow: hidden;
`;

export const ProductLayout = styled.div`
  display: grid;
  grid-template-columns: 1fr 340px;
  gap: 0;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const ImageSection = styled.div`
  padding: 32px;
  display: flex;
  flex-direction: column;
  border-right: 1px solid #eee;
  min-height: 400px;

  @media (max-width: 768px) {
    border-right: none;
    border-bottom: 1px solid #eee;
    padding: 16px;
    min-height: auto;
  }
`;

export const BuySection = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media (max-width: 768px) {
    padding: 16px;
  }
`;

export const DescriptionSection = styled.div`
  padding: 32px;
  border-top: 1px solid #eee;

  @media (max-width: 768px) {
    padding: 16px;
  }
`;

export const Condition = styled.div`
  font-size: 13px;
  color: #999;

  a {
    color: ${props => props.theme?.name === "equi" ? "#2D68C4" : "#3483fa"};
  }
`;

export const Nome = styled.div`
  font-size: 22px;
  font-weight: 600;
  color: #333;
  line-height: 1.3;
`;

export const Preco = styled.div`
  font-size: 36px;
  font-weight: 400;
  color: #333;
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 8px;
`;

export const StockInfo = styled.div`
  font-size: 14px;
  color: #333;

  strong {
    color: #00a650;
  }
`;

export const Select = styled.select`
  font-size: 14px;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-family: 'Montserrat', sans-serif;
  background: #fff;
  cursor: pointer;
  color: #333;
  width: 100%;
`;

export const QtyWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const QtyButton = styled.button`
  width: 40px;
  height: 42px;
  border: 1px solid #ddd;
  border-radius: 6px;
  background: #fff;
  font-size: 20px;
  line-height: 1;
  color: ${(props) => (props.theme?.name === "equi" ? "#2D68C4" : "#3483fa")};
  cursor: pointer;
  font-family: 'Montserrat', sans-serif;

  &:disabled {
    color: #ccc;
    cursor: not-allowed;
  }
`;

export const QtyInput = styled.input`
  width: 90px;
  height: 42px;
  text-align: center;
  font-size: 16px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-family: 'Montserrat', sans-serif;
  background: #fff;
  color: #333;

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  -moz-appearance: textfield;
`;

export const QtyHint = styled.span`
  font-size: 12px;
  color: #999;
  margin-left: 4px;
`;

export const BuyButton = styled.button`
  width: 100%;
  padding: 14px;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 600;
  font-family: 'Montserrat', sans-serif;
  cursor: pointer;
  transition: all 0.2s;
  background: ${props => props.theme?.name === "equi" ? "#2D68C4" : "#3483fa"};
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  &:hover {
    opacity: 0.9;
  }
`;

export const NotifyButton = styled(BuyButton)`
  background: ${props => props.theme.primary};
`;

export const ShippingInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 0;
  border-top: 1px solid #eee;
  font-size: 14px;
`;

export const ShippingText = styled.div`
  color: #00a650;
  font-weight: 600;
`;

export const ShippingDetail = styled.div`
  color: #999;
  font-size: 12px;
`;

export const VariantOption = styled.div`
  padding: 8px 16px;
  border: 1px solid ${props => props.$selected ? (props.theme?.name === "equi" ? "#2D68C4" : "#3483fa") : "#ddd"};
  border-radius: 6px;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s;
  font-family: 'Montserrat', sans-serif;
  background: ${props => props.$selected ? (props.theme?.name === "equi" ? "#e0ecff" : "#f0f7ff") : "#fff"};
  font-weight: ${props => props.$selected ? 600 : 400};
  color: ${props => props.$selected ? (props.theme?.name === "equi" ? "#2D68C4" : "#3483fa") : "#333"};

  &:hover {
    border-color: ${props => props.theme?.name === "equi" ? "#2D68C4" : "#3483fa"};
  }
`;

export const Esgotado = styled.div`
  font-size: 16px;
  color: #999;
  font-weight: 600;
  margin-top: 10px;
  padding: 12px;
  background: #f5f5f5;
  border-radius: 6px;
  text-align: center;
`;

export const Vendidos = styled.div`
  font-size: 14px;
  color: #a5a5a5;
`;
